import { LeaveDialog } from '@ipfabric/ui-components/LeaveDialog/LeaveDialog';
import { PageHeader } from '@ipfabric/ui-components/PageHeader/PageHeader';
import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';
import { isNonNullable } from '@ipfabric/utils';
import type { ReactNode } from 'react';
import type { WizardPageProps } from './configWizard.types';

type Props = Pick<WizardPageProps, 'wizardStepper'> & {
  canNavigate?: boolean;
  children: ReactNode;
  formComposition?: FormCompositionHook<never>;
  title?: string;
};

export const WizardPageTemplate = ({ canNavigate = true, ...props }: Props) => {
  const isSubmitting =
    props.formComposition?.form.formState.isSubmitting ?? false;
  const isDirty = props.formComposition?.form.formState.isDirty ?? false;

  return (
    <>
      {props.formComposition && <LeaveDialog dirty={isDirty} />}
      <PageHeader
        elevated
        width='content-default'
        label='Configuration Wizard'
        additionalControls={props.wizardStepper(
          isSubmitting,
          isDirty ? props.formComposition?.makeHandleSubmit : undefined,
          canNavigate === false,
        )}
      />
      <div className='flex flex-col items-center'>
        <div className='w-full max-w-content-default flex flex-col px my gap'>
          {isNonNullable(props.title) && (
            <div className='text-2xl font-semibold text-default'>
              {props.title}
            </div>
          )}
          {props.children}
        </div>
      </div>
    </>
  );
};
